module.exports = __webpack_public_path__ + "media/images/pc/articles/area_map-ef02b0195a5e09a5df909f3d949316fa.webp";